import { Modal } from 'antd';
import { type ReactNode } from 'react';
import { type LocalDate } from '../../../utils/local-date';

interface Props {
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  sitesNames: string;
  orderDate?: LocalDate;
}
const SitesWithExistingOrdersModal = ({
  isOpen,
  onOk,
  onCancel,
  sitesNames,
  orderDate,
}: Props): ReactNode => {
  return (
    <Modal
      open={isOpen}
      okText="proceed"
      cancelText="Cancel"
      onOk={onOk}
      onCancel={onCancel}
      title="Existing Orders Found"
      zIndex={1001}
    >
      <div>
        <p>The following sites:</p>
        <b>{sitesNames}</b>
        <p>already have orders scheduled for this date:</p>
        <b>{`${orderDate?.toString() ?? ''}`}</b>
        <p>Do you still want to proceed ?</p>
      </div>
    </Modal>
  );
};

export default SitesWithExistingOrdersModal;
